<template>
  <div :class="['overlay', type]" ref="rootRef">
    <template v-if="type === 'tap'">
      <div class="overlay__frame tap">
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>

        <div class="perspective-wrapper">
          <SvgSprite
            symbol="ui-advergaming-overlay-hand"
            size="43 50"
            class="overlay__hand js-hand"
          />
        </div>
      </div>
    </template>
    <template v-else-if="type === 'drag'">
      <div class="overlay__frame">
        <SvgSprite
          symbol="ui-advergaming-overlay-hand"
          size="43 50"
          class="overlay__hand js-hand"
        />

        <svg
          width="91"
          height="27"
          fill="none"
          viewBox="0 0 91 27"
          xmlns="http://www.w3.org/2000/svg"
          class="arrow"
        >
          <g filter="url(#a)">
            <mask
              id="b"
              maskUnits="userSpaceOnUse"
              x="2"
              y="1.003"
              width="86"
              height="22"
              fill="#000"
            >
              <rect fill="#fff" x="2" y="1.003" width="86" height="22" />
              <path
                d="M16.41 8.446a1 1 0 0 0 1 1h55.202a1 1 0 0 0 1-1v-3.44a1 1 0 0 1 1.61-.792l9.41 7.253c.52.4.52 1.185 0 1.585l-9.41 7.253a1 1 0 0 1-1.61-.792v-3.44a1 1 0 0 0-1-1H44.01v-.001h-26.6a1 1 0 0 0-1 1v3.44a1 1 0 0 1-1.61.792l-9.411-7.253a1.001 1.001 0 0 1 0-1.585l9.41-7.253a1 1 0 0 1 1.611.792v3.44Z"
              />
            </mask>
            <path
              d="M16.41 8.446a1 1 0 0 0 1 1h55.202a1 1 0 0 0 1-1v-3.44a1 1 0 0 1 1.61-.792l9.41 7.253c.52.4.52 1.185 0 1.585l-9.41 7.253a1 1 0 0 1-1.61-.792v-3.44a1 1 0 0 0-1-1H44.01v-.001h-26.6a1 1 0 0 0-1 1v3.44a1 1 0 0 1-1.61.792l-9.411-7.253a1.001 1.001 0 0 1 0-1.585l9.41-7.253a1 1 0 0 1 1.611.792v3.44Z"
              fill="#3C3232"
            />
            <path
              d="M75.222 4.214 74 5.798l1.22-1.584Zm9.41 7.253 1.222-1.584-1.221 1.584Zm0 1.585 1.222 1.584-1.221-1.584Zm-9.41 7.253L74 18.721l1.22 1.584Zm-60.422 0 1.22-1.585-1.22 1.584ZM5.389 13.05l-1.221 1.584 1.22-1.584Zm0-1.585L4.168 9.882l-.001.001 1.222 1.583Zm9.41-7.253 1.222 1.585L14.8 4.212Zm2.611 5.233v2h28.601v-4h-28.6v2Zm28.602 0v2h26.6v-4h-26.6v2Zm27.6-1h2v-3.44h-4v3.44h2Zm1.61-4.232L74 5.798l9.411 7.253 1.22-1.584 1.222-1.584-9.412-7.253-1.22 1.584Zm9.41 8.838-1.22-1.584-9.411 7.253 1.22 1.584 1.221 1.584 9.412-7.253-1.221-1.584Zm-11.02 6.461h2v-3.44h-4v3.44h2Zm-1-4.44v-2H44.01v4h28.601v-2Zm-28.603-.001v-2H17.41v4h26.6v-2Zm-27.599 1h-2v3.44h4v-3.44h-2Zm-1.61 4.232 1.22-1.584-9.41-7.253-1.221 1.584-1.221 1.584 9.41 7.253 1.222-1.584Zm-9.411-8.838 1.22 1.585 9.412-7.253L14.8 4.213 13.579 2.63 4.168 9.882l1.22 1.584Zm11.021-6.46h-2v3.44h4v-3.44h-2Zm-1.61-.793 1.22 1.584a1 1 0 0 1-1.61-.792h4c0-2.49-2.859-3.896-4.831-2.376l1.22 1.584Zm-9.411 8.838 1.22-1.584a.999.999 0 0 1 .002 1.582l-1.222-1.583-1.222-1.583a3.001 3.001 0 0 0 0 4.752l1.222-1.584Zm11.021 6.461h-2a1 1 0 0 1 1.61-.792l-1.22 1.584-1.221 1.584c1.972 1.52 4.831.114 4.831-2.376h-2Zm58.812.793L74 18.721a1 1 0 0 1 1.61.792h-4c0 2.49 2.86 3.896 4.832 2.376l-1.221-1.584Zm9.41-8.838-1.22 1.584a.999.999 0 0 1-.001-1.582l1.222 1.583 1.222 1.584a3.001 3.001 0 0 0-.001-4.753l-1.221 1.584Zm-11.02-6.46h2A1 1 0 0 1 74 5.797l1.22-1.584 1.222-1.584c-1.973-1.52-4.832-.114-4.832 2.376h2ZM17.41 15.071v-2a3 3 0 0 0-3 3h4a1 1 0 0 1-1 1v-2Zm55.201-5.625v2a3 3 0 0 0 3-3h-4a1 1 0 0 1 1-1v2ZM44.01 15.072h2a2 2 0 0 0-2-2v4a2 2 0 0 1-2-2h2Zm2.002-5.626h-2a2 2 0 0 0 2 2v-4a2 2 0 0 1 2 2h-2Zm-2.002 5.627v-2a2 2 0 0 1 2 2h-4a2 2 0 0 0 2 2v-2Zm2.001-5.627v2a2 2 0 0 1-2-2h4a2 2 0 0 0-2-2v2Zm27.6 6.627h2a3 3 0 0 0-3-3v4a1 1 0 0 1-1-1h2Zm-56.2-6.627v-2a1 1 0 0 1 1 1h-4a3 3 0 0 0 3 3v-2Z"
              fill="#E3FCFF"
              mask="url(#b)"
            />
          </g>
          <defs>
            <filter
              id="a"
              x="0"
              y="0"
              width="90.022"
              height="26.519"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_5848_930"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_5848_930"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </template>
    <template v-else-if="type === 'keys'">
      <div class="keypad">
        <div class="keypad__key--top disabled">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="keypad__key__arrow"
          />
        </div>
        <div class="keypad__key--down disabled">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="keypad__key__arrow"
          />
        </div>
        <div class="keypad__key--left js-keypad-arrow-left">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="keypad__key__arrow"
          />
        </div>
        <div class="keypad__key--right js-keypad-arrow-right">
          <SvgSprite
            symbol="ui-advergaming-overlay-arrow-key"
            size="19 21"
            class="keypad__key__arrow"
          />
        </div>
      </div>
    </template>
    <template v-else-if="type === 'mouse'">
      <div class="overlay__frame mouse">
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>
        <div class="dash">
          <div class="dash__fill js-dash"></div>
        </div>

        <div class="perspective-wrapper">
          <SvgSprite
            symbol="ui-advergaming-overlay-mouse"
            size="43 50"
            class="overlay__mouse js-mouse"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import gsap from 'gsap'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { useMediaQuery } from '@vueuse/core'

type Overlay = 'tap' | 'drag' | 'keys' | 'none' | 'mouse'

const props = defineProps<{
  desktop: Overlay
  mobile: Overlay
}>()

let overlayContentTL: gsap.core.Timeline | undefined
const rootRef = ref()

// Depending on the user device, we switch between different gesture animations.
// If the primary input method is coarse, we assume that user is using touch device and choose the mobile props overlay.
// If not, we use the desktop prop overlay.
const isTouchScreen = useMediaQuery('(pointer: coarse)')
const type = computed<Overlay>(() => {
  if (isTouchScreen.value) {
    return props.mobile
  }

  return props.desktop
})
// Re-init animation when type changes
watch(type, () => {
  // Watch for DOM to be updated otherwise gsap won't find what it is looking for
  nextTick(() => {
    initAnimation()
  })
})

onMounted(() => {
  initAnimation()
})

const initAnimation = () => {
  overlayContentTL?.kill()

  switch (type.value) {
    case 'tap':
      overlayContentTL = initTapAnimation()
      break
    case 'drag':
      overlayContentTL = initDragAnimation()
      break
    case 'keys':
      overlayContentTL = initArrowKeysAnimation()
      break
    case 'mouse':
      overlayContentTL = initMouseAnimation()
      break

    default:
      break
  }
}

const initTapAnimation = () => {
  const handEl = rootRef.value.querySelector('.js-hand')
  const dashEls = rootRef.value.querySelectorAll('.js-dash')

  if (!handEl || dashEls.length < 1) {
    return
  }

  const DURATION_FORWARD = 0.5 // Durée du mouvement "avant"
  const DURATION_BACKWARD = 0.5 // Durée du mouvement "retour"
  const REPEAT_DELAY = 0.25
  const LABEL_CLICK = 'click'

  // Note: défini explicitement mouvement aller et retour parce que plus flexible que d'utiliser yoyo (délai entre répétions, eases individuels...)
  const TL = gsap.timeline({
    repeat: -1,
    repeatDelay: REPEAT_DELAY,
  })

  // Hand - Forward motion
  TL.fromTo(
    handEl,
    {
      transform: 'rotate3d(1, 0.25, 0, 0deg)',
    },
    {
      transform: 'rotate3d(1, 0.25, 0, 20deg)',
      ease: 'power4.in',
      duration: DURATION_FORWARD,
    }
  )

  TL.addLabel(LABEL_CLICK)

  // Dashes - in motion
  TL.set(
    dashEls,
    {
      transformOrigin: '100% 50%',
    },
    LABEL_CLICK
  ).fromTo(
    dashEls,
    {
      scaleX: 0,
    },
    {
      scaleX: 1,
      duration: 0.1,
    },
    LABEL_CLICK
  )

  // Dashes - out motion
  TL.set(dashEls, {
    transformOrigin: '0% 50%',
  }).to('.js-dash', {
    scaleX: 0,
    duration: 0.1,
  })

  // Hand - backward motion
  TL.to(
    handEl,
    {
      transform: 'rotate3d(1, 0.25, 0, 0deg)',
      ease: 'power4.out',
      duration: DURATION_BACKWARD,
    },
    LABEL_CLICK
  )

  return TL
}

const initDragAnimation = () => {
  const handEl = rootRef.value.querySelector('.js-hand')

  if (!handEl) {
    return
  }

  const DURATION_DRAG = 0.5
  const REPEAT_DELAY = 0.25

  const TL = gsap.timeline({
    repeat: -1,
    repeatDelay: REPEAT_DELAY,
  })

  TL.fromTo(
    handEl,
    {
      x: -10,
      y: -15,
      rotate: -20,
    },
    {
      x: 10,
      y: -15,
      rotate: 20,
      ease: 'power1.inOut',
      duration: DURATION_DRAG,
    }
  )

  TL.to(
    handEl,
    {
      x: -10,
      y: -15,
      rotate: -20,
      ease: 'power1.inOut',
      duration: DURATION_DRAG,
    },
    `+=${REPEAT_DELAY}`
  )

  return TL
}

const initArrowKeysAnimation = () => {
  const arrowLeftEl = rootRef.value.querySelector('.js-keypad-arrow-left')
  const arrowRightEl = rootRef.value.querySelector('.js-keypad-arrow-right')

  if (!arrowLeftEl || !arrowRightEl) {
    return
  }

  const DURATION_KEYPRESS = 0.2
  const SHADOW_KEY_PRESSED = 2
  const SHADOW_KEY_RELEASED = 8
  const REPEAT_DELAY = 0.25
  const Y_DISTANCE = 6

  const TL = gsap.timeline({
    repeat: -1,
    repeatDelay: REPEAT_DELAY,
  })

  // Left key goes down
  TL.to(arrowLeftEl, {
    y: Y_DISTANCE,
    '--shadow-y': SHADOW_KEY_PRESSED,
    duration: DURATION_KEYPRESS,
  })

  // Left key goes up
  TL.to(arrowLeftEl, {
    y: 0,
    '--shadow-y': SHADOW_KEY_RELEASED,
  })

  // Right key goes down
  TL.to(
    arrowRightEl,
    {
      y: Y_DISTANCE,
      '--shadow-y': SHADOW_KEY_PRESSED,
      duration: DURATION_KEYPRESS,
    },
    `+=${REPEAT_DELAY}`
  )

  // Right key goes up
  TL.to(arrowRightEl, {
    y: 0,
    '--shadow-y': SHADOW_KEY_RELEASED,
  })

  return TL
}

const initMouseAnimation = () => {
  const mouseEl = rootRef.value.querySelector('.js-mouse')
  const dashEls = rootRef.value.querySelectorAll('.js-dash')

  if (!mouseEl || dashEls.length < 1) {
    return
  }

  const DURATION_FORWARD = 0.1 // Durée du mouvement "avant"
  const DURATION_BACKWARD = 0.1 // Durée du mouvement "retour"
  const REPEAT_DELAY = 0.75
  const LABEL_CLICK = 'click'

  // Note: défini explicitement mouvement aller et retour parce que plus flexible que d'utiliser yoyo (délai entre répétions, eases individuels...)
  const TL = gsap.timeline({
    repeat: -1,
    repeatDelay: REPEAT_DELAY,
  })

  // Mouse - Forward motion
  TL.fromTo(
    mouseEl,
    {
      transform: 'rotate3d(1, -1, 0, 0deg)',
      rotateX: 0,
      rotateY: 0,
    },
    {
      transform: 'rotate3d(1, -1, 0, 20deg)',
      ease: 'power1.in',
      duration: DURATION_FORWARD,
    }
  )

  TL.addLabel(LABEL_CLICK)

  // Dashes - in motion
  TL.set(
    dashEls,
    {
      transformOrigin: '100% 50%',
    },
    LABEL_CLICK
  ).fromTo(
    dashEls,
    {
      scaleX: 0,
    },
    {
      scaleX: 1,
      duration: 0.1,
    },
    LABEL_CLICK
  )

  // Dashes - out motion
  TL.set(dashEls, {
    transformOrigin: '0% 50%',
  }).to('.js-dash', {
    scaleX: 0,
    duration: 0.1,
  })

  // Mouse - backward motion
  TL.to(
    mouseEl,
    {
      transform: 'rotate3d(1, -1, 0, 0deg)',
      ease: 'power1.in',
      duration: DURATION_BACKWARD,
    },
    LABEL_CLICK
  )

  return TL
}
</script>

<style lang="scss" scoped>
$c-main: #e3fcff;
$c-main-dimmed: rgba(227, 252, 255, 30%);
$c-bg: #3c3232;

.overlay {
  position: absolute;
  inset: 0;

  &.none {
    display: none;
  }
}

.overlay__frame {
  position: absolute;
  top: 50%;
  left: 50%;
  display: grid;
  place-items: center;
  width: 12rem;
  height: 12rem;
  translate: -50% -50%;
  background-color: rgba(60, 50, 50, 80%);
  border: 0.2rem $c-main solid;
  border-radius: 0.4rem;
}

.overlay__hand {
  display: block;
  stroke: $c-main;
  stroke-width: 0.2rem;
  fill: rgba(60, 50, 50, 80%);
  transform-origin: 50% 70%;
}

.overlay__mouse {
  width: 3.6rem;
  height: auto;
  stroke: $c-main;
  stroke-width: 0.2rem;
  fill: rgba(60, 50, 50, 80%);
  transform-origin: 100% 100%;
  transform: rotate3d(1, -1, 0, 20deg);
}

.dash {
  position: absolute;

  &:nth-child(1) {
    top: 4rem;
    left: 2.5rem;
  }

  &:nth-child(2) {
    top: 2.8rem;
    left: 2.9rem;
    transform: rotate(45deg);
  }

  &:nth-child(3) {
    top: 2.5rem;
    left: 4rem;
    transform: rotate(90deg);
  }
}

.dash__fill {
  width: 1.13rem;
  height: 0.2rem;
  background-color: $c-main;
  transform-origin: 100% 50%;
}

.tap {
  .dash {
    translate: 6px 0;
  }

  .perspective-wrapper {
    perspective: 80px;
    perspective-origin: 0 0;
  }
}

.mouse {
  .perspective-wrapper {
    perspective: 80px;
    perspective-origin: 0 0;
  }

  .dash {
    translate: 2px -5px;

    &:nth-child(1) {
      top: 4.5rem;
      left: 2.4rem;
    }

    &:nth-child(2) {
      top: 3.2rem;
      left: 2.6rem;
    }

    &:nth-child(3) {
      top: 2.8rem;
      left: 3.8rem;
    }
  }
}

.drag {
  .arrow {
    position: absolute;
    bottom: 1rem;
    width: 75%;
    height: auto;
  }
}

.keypad {
  --key-size: 6.44rem;

  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  display: grid;
  grid-template-rows: repeat(2, var(--key-size));
  grid-template-columns: repeat(3, var(--key-size));
  gap: 0.55rem;
}

.keypad__key__arrow {
  fill: $c-main;
}

[class*='keypad__key--'] {
  --shadow-y: 8px;

  display: grid;
  place-items: center;
  width: 6.44rem;
  height: 6.44rem;
  background-color: #3c3232;
  border: 0.1rem solid $c-main;
  border-radius: 0.4rem;
  box-shadow: rgb(0, 0, 0, 25%) 0 var(--shadow-y) 0;

  &[class*='--top'] {
    grid-row: 1/2;
    grid-column: 2/3;

    .keypad__key__arrow {
      rotate: 90deg;
    }
  }

  &[class*='--down'] {
    grid-row: 2/3;
    grid-column: 2/3;

    .keypad__key__arrow {
      rotate: -90deg;
    }
  }

  &[class*='--left'] {
    grid-row: 2/3;
    grid-column: 1/2;
  }

  &[class*='--right'] {
    grid-row: 2/3;
    grid-column: 3/4;

    .keypad__key__arrow {
      rotate: 180deg;
    }
  }

  &.disabled {
    border-color: $c-main-dimmed;

    .keypad__key__arrow {
      fill: $c-main-dimmed;
    }
  }
}
</style>
